<div *ngIf="isReactive" class="itb-datepicker" [ngClass]="{'datepicker-disabled': isDisabled}" [formGroup]="parentForm">
    <mat-form-field>
        <input matInput [required]="isRequired" [matDatepicker]="picker"
               placeholder="{{placeholder}}"
               [formControl]="formFieldName"
               [value]="date"
               (dateChange)="changeEvent($event)"
               (focus)="picker.open()"
               (focusout)="onFocusOut()"
               (keyup)="checkForDate($event)"
               (focus)="onFocusIn()">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>

<div *ngIf="!isReactive" class="itb-datepicker" [ngClass]="{'datepicker-disabled': isDisabled,'datepicker-disabled-required': isRequired && isDisabled}">
    <mat-form-field>
        <mat-label>{{placeholder}}<span *ngIf="isRequired" class="label-required">*</span></mat-label>
        <input matInput [required]="isRequired" [matDatepicker]="picker"
               [value]="date"
               [disabled]="isDisabled"
               (dateChange)="changeEvent($event)"
               (focus)="picker.open()"
               (focusout)="onFocusOut()"
               (keyup)="checkForDate($event)"
               (focus)="onFocusIn()">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>